<template>
  <div>
    <!-- タイトル -->
    <span class="color">
      {{ $t("label.system.meetingRoom.create.loanDetail") }}
    </span>
    <el-table
      :data="result"
      :fit="true"
      width="100%"
      class="m-top-5 table-header-th-top-0"
    >
      <!-- テナント名 -->
      <el-table-column
        class-name="col-8"
        prop="tenantName"
        :label="$t('label.system.meetingRoom.create.tenantName')"
      />

      <!-- 入居年月日 -->
      <el-table-column
        prop="moveInDate"
        :label="$t('label.system.meetingRoom.create.moveInDate')"
        class-name="col-4"
      />

      <!-- 退去年月日 -->
      <el-table-column
        prop="moveOutDate"
        :label="$t('label.system.meetingRoom.create.moveOutDate')"
        class-name="col-4"
      />

      <!-- 貸出曜日 -->
      <el-table-column
        prop="loanDay"
        :label="$t('label.system.meetingRoom.create.loanDay')"
        class-name="col-4"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  name: "MeetingRoomACResultBeautify",
  data() {
    return {};
  },
  props: {
    result: Array,
  },
};
</script>

<style scoped>
.color {
  color: #525250;
  font-size: 16px;
}
::v-deep .el-table__header {
  height: 20px;
}
::v-deep .el-table th,
.el-table td {
  padding: 3px 0;
}
::v-deep .cell {
  font-size: 12px;
  line-height: 14px;
}
::v-deep .el-table th > .cell {
  padding-left: 8px;
  padding-right: 0;
}
::v-deep .el-table .cell {
  font-size: 12px;
}
::v-deep .el-table th > .cell {
  font-size: 12px !important;
}
.blank{
  height: 16px;
  display: block;
}
</style>
